<template>
    <div class="growingbranches-wrapper">
        <img loading="lazy" class="growingbranches-img" :src="require(`@/assets/img/aro-kraken.png`)" alt="">
        <div class="growingbranches-left">
            <div class="growingbranches-step">
                <h2 class="growingbranches-step-title">01. Inicio del proyecto</h2>
                <p class="growingbranches-step-desc">Se realiza una toma de requisitos específica para el cliente y se diseña una maquetación básica de la estructura del proyecto.</p>
            </div>
            <div class="growingbranches-step">
                <h2 class="growingbranches-step-title">03. Diseño</h2>
                <p class="growingbranches-step-desc">Tras aceptar la maquetación se empieza con el diseño web avanzado, se implementará y se realizará el bruto de la web, incluyendo textos, imágenes, animaciones y efectos que darán vida a la web.</p>
            </div>
            <div class="growingbranches-step">
                <h2 class="growingbranches-step-title">05. Tu web está lista</h2>
                <p class="growingbranches-step-desc">Llegados a este punto nuestra web terminada y preparada para recibir tráfico online, es el momento de contactar con el cliente y empezar a promocionarla para llegar a más clientes. <br>Tu web está en el aire!</p>
            </div>
        </div>
        <div class="growingbranches-right">
            <div class="growingbranches-step">
                <h2 class="growingbranches-step-title">02. Feedback</h2>
                <p class="growingbranches-step-desc">La maquetación se comparte con el cliente se le solicita feedback, para retocar aspectos del diseño y que queden a gusto del cliente. (Imprescindible, ya que es una prioridad que quedes satisfecho con tu web)</p>
            </div>
            <div class="growingbranches-step">
                <h2 class="growingbranches-step-title">04. Presentación + feedback</h2>
                <p class="growingbranches-step-desc">Se presenta la web final al cliente, éste dará el visto bueno al proyecto y procederemos a su implantación en el servidor web, su alta en servicios de indexación y a realizar las últimas configuraciones necesarias para su correcto funcionamiento.</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue'

    export default Vue.extend({
        name: 'GrowingBranches'
    })
</script>

<style scoped lang="scss">
    .growingbranches {
        &-wrapper {
            display: flex;
            min-height: 100px;
            padding-top: 250px;
            padding-bottom: 130vmax;
        }

        &-img {
            position: absolute;
            left: 50%;
            top: 0;
            transform: translateX(-50%);
            -webkit-transform: translateX(-50%);
            max-height: 200px;
            z-index: 1;
        }

        &-left {
            width: 50%;
            display: flex;
            justify-content: space-evenly;
            align-items: flex-end;
            flex-direction: column;
            position: relative;

            &::before {
                content: '';
                width: 1px;
                height: 100%;
                background-color: #fff;
                position: absolute;
                right: 0;
                top: -80px;
                z-index: 0;
            }

            & .growingbranches-step {
                text-align: right;

                &-title {
                    margin-left: auto;
                    padding-right: .8rem;
                }

                &-desc {
                    padding-right: .8rem;
                    font-size: .95rem;
                    margin-left: auto;
                }
            }
        }

        &-right {
            width: 50%;
            display: flex;
            justify-content: stretch;
            align-items: flex-start;
            flex-direction: column; 
            padding-top: 14vmax;

            & .growingbranches-step {
                text-align: left;

                &-title {
                    margin-right: auto;
                    padding-left: .8rem;
                }

                &-desc {
                    padding-left: .8rem;
                    font-size: .95rem;
                    margin-right: auto;
                }
            }
        }

        &-step {
            color: #fff;
            padding-bottom: 18vmax;
            max-width: 800px;

            &-title {
                letter-spacing: 1px;
                font-weight: 500;
                font-size: 1.2rem;
                border-bottom: 1px solid #fff;
                margin-bottom: .5rem;
                padding-bottom: .5rem;
                width: 80%;
            }
            &-desc {
                color: #fff;
                padding-right: .5rem;
                width: 80%;
                font-weight: 300;
            }
        }

        @media SCREEN AND ( min-width: 768px ) {
            &-step {
                opacity: 0;
            }

            &-wrapper {
                padding-bottom: 0;
            }

            &-left,
            &-right {
                & .growingbranches-step {
                    &-title {
                        font-size: 1.5rem;
                        margin-bottom: .5rem;
                    }
                    &-desc {
                        font-size: 1.3rem;
                    }
                }
            }
        }

        @media SCREEN AND ( min-width: 992px ) {
            &-step {
                &-title {
                    font-size: 2.3rem;
                }
                &-desc {
                    font-size: 1.4rem;
                }
            }
        }

        @media SCREEN AND ( min-width: 1800px ) {
            &-step {
                padding-bottom: 15vmax;
            }

            &-right { 
                padding-top: 12vmax;
                & .growingbranches-step {
                    padding-bottom: 15vmax;
                }
            }
        }
    }
</style>